import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonAnchorRegion } from './AnchoredRegion.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonAnchorRegion({ prefix }));
}
